import React, { useState, useEffect, useContext, useCallback } from "react";
import { useHistory } from "react-router-dom";
import DispatchContext from "../../contexts/DispatchContext";
import DataFetcher from "../../utils/DataFetcher";
import { sortBy, getResponse, dispError, dispSuccess } from "../../utils/Tools";

import Card from "../elements/Card";
import FilterBar from "../elements/FilterBar";
import LoadingIndicator from "../elements/LoadingIndicator";
import NoResults from "../elements/NoResults";

function Clients(props) {
  const appDispatch = useContext(DispatchContext);
  const history = useHistory();
  const [clients, setData] = useState(null);

  const loadData = useCallback(() => {
    DataFetcher.fetch(DataFetcher.CLIENT.LIST)
      .then(response => {
        if (!response.success) {
          appDispatch(dispError(response.msg));
          return history.push("/");
        }
        let clients = response.list.map(item => {
          // delete item.logo;
          item.visible = true;
          return item;
        });
        return setData(clients);
      })
      .catch(error => {
        console.error(error);
        return history.push("/");
      });
  }, [appDispatch, history]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  useEffect(() => {
    window.document.title = props.title;
  }, [props.title]);

  const filterOps = [
    { type: "text", key: "name", label: "Mandant" },
    { type: "text", key: "address.city", label: "Ort" },
    { type: "date", key: "created_at", label: "Datum" },
    { type: "bool", key: "isActivated", label: "Status", switchLabel: "Aktiviert?" }
  ];
  const onFilter = filtered => setData(filtered);

  const onDelete = id => {
    let confirm = window.confirm(getResponse("003a"));
    if (confirm) {
      DataFetcher.fetch(DataFetcher.CLIENT.DELETE, { _id: id })
        .then(response => {
          if (!response.success) {
            appDispatch(dispError(response.msg));
            return history.push("/");
          }
          appDispatch(dispSuccess(getResponse("003b")));
          return loadData();
        })
        .catch(error => {
          console.error(error);
          return history.push("/");
        });
    }
  };

  return (
    <main className="clients">
      {!clients && <LoadingIndicator />}
      {clients && (
        <>
          <h1 className="title">Mandanten&shy;übersicht</h1>
          <p>In diesem Bereich können Sie Ihre Mandanten verwalten.</p>
          <FilterBar source={clients} filterOptions={filterOps} onFilter={onFilter} />
          {!clients.filter(client => client.visible).length ? (
            <NoResults msg="Keine Ergebnisse" />
          ) : (
            <>
              <section className="tiles">
                {clients.sort(sortBy("name")).map(client => {
                  if (!client.visible) return null;
                  return <Card data={client} mode={"client"} key={client._id} onDelete={onDelete} />;
                })}
              </section>
            </>
          )}
        </>
      )}
    </main>
  );
}
export default Clients;
